import { Component, OnInit, forwardRef, ChangeDetectionStrategy } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormArray, UntypedFormBuilder } from '@angular/forms'
import { TagControlComponentBase } from 'src/app/shared/tag-control-base'
import { Tag, TagList } from 'src/utils/types'

@Component({
  selector: 'account-tags-form-control',
  templateUrl: './account-tags-form-control.component.html',
  styleUrls: ['./account-tags-form-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AccountTagsFormControlComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AccountTagsFormControlComponent extends TagControlComponentBase {}
